import { getUser } from "./authService";
import http, { host } from "./httpService";
import { standerdDate, standerdDateForDataCreation } from "../utils/dataFilter";

export const getAggregateDailyContainerPlanning = async (date) => {
  return await http.get(host + "GetDailyContainerPlanningAggregateData", {
    params: { _DDate: date },
  });
};

export const uploadAggregateDailyPlan = async (plan) => {
  return await http.post(host + "AddDailyContainerPlanningAggregateData", {
    _jsonDailyplanAggregatelist: plan,
  });
};

export const getAggregateMonthlyContainerPlanning = async (month) => {
  return await http.get(host + "GetMonthlyContainerPlanningAggregateDataJD", {
    params: { planningMonth: month },
  });
};

export const getAggregateWeeklyPlan = async (month, type) => {
  return await http.get(
    host + "GetWeeklyContainerPlanningAggregateFromMonthlySheetJD",
    { params: { planningMonth: month, Type: type } }
  );
};

export const createAggregateMonthlyPlan = async (plan) => {
  return await http.post(host + "AddMonthlyContainerPlanningAggregateData", {
    _jsonMonthlyAggrigatelist: plan,
  });
};

export const getDailyContainerPlanningAggregate = async (month) => {
  return await http.get(host + "GetDailyAggregateShipmentActualData", {
    params: { _jdmonth: month },
  });
};

export const insertAggregateBookingNumber = async ({
  DailyContainerPlanningAggregateId,
  BookingNo,
  BookedBy,
}) => {
  const formData = new FormData();
  formData.append(
    "DailyContainerPlanningAggregateId",
    DailyContainerPlanningAggregateId
  );
  formData.append("BookingNo", BookingNo);
  formData.append("BookedBy", BookedBy);
  return await http.post(
    host + "AddBookingNumberForDailyContainerPlanningAggregate",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const insertBulkAggregateBookingNumber = async (data) =>{
  return await http.post(host + "AddAggregateBulckBooking", {_jsonAggrBookingList : data})
}

export const updateBulkAggregateBookingNumberWithReason = async (data) =>{
  return await http.put(host + "UpdateBulkAggregateBookingNumberWithReason", {_jsonAggrNowithReason : data})
}
export const sendBulkReasonsforhold= async (data) => {
  // const formData = new FormData();
  // formData.append("DailyContainerPlanningId", DailyContainerPlanningId);
  // formData.append("Reason", Reason);
  // formData.append("SendApprovalBy", SendApprovalBy);
  return await http.put(host + "UpdateBulkHoldStatus_Aryabhatta", {_jsonUpdateBulkHoldStatus_AryabhattaList: data});
};

export const updateAggregateBookingNumber = async ({
  AssignContainerAggregateId,
  BookingNo,
  BookedBy,
}) => {
  const formData = new FormData();
  formData.append(
    "assignContainerPlanningAggregateId",
    AssignContainerAggregateId
  );
  formData.append("bookingNo", BookingNo);
  formData.append("bookedBy", BookedBy);
  return await http.put(
    host + "UpdateBookingNumberForDailyContainerPlanningAggregate",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const updateAggregateContainer = async (formData) => {
  return await http.put(host + "UpdateAggregateContainerNumber", formData);
};

export const updateAggregateBulkContainer = async (data) => {
  return await http.put(host + "UpdateAggregatebulkContainerNumber", data);
};

export const sendAggregateReasonsToJD = async ({
  DailyContainerPlanningAggregateId,
  Reason,
  manualReason,
  SendApprovalBy,
}) => {
  if(Reason === "" && manualReason !== ""){
    const formData = new FormData();
  formData.append(
    "DailyContainerPlanningAggregateId",
    DailyContainerPlanningAggregateId
  );
  formData.append("Reason", `${manualReason}`);
  formData.append("SendApprovalBy", SendApprovalBy);
  return await http.post(host + "AddSendReasonAggregateToJD", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
else if(Reason !== "" && manualReason !== ""){
  const formData = new FormData();
  formData.append(
    "DailyContainerPlanningAggregateId",
    DailyContainerPlanningAggregateId
  );
  formData.append("Reason", `${Reason},${manualReason}`);
  formData.append("SendApprovalBy", SendApprovalBy);
  return await http.post(host + "AddSendReasonAggregateToJD", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
} else{
  const formData = new FormData();
  formData.append(
    "DailyContainerPlanningAggregateId",
    DailyContainerPlanningAggregateId
  );
  formData.append("Reason", Reason);
  formData.append("SendApprovalBy", SendApprovalBy);
  return await http.post(host + "AddSendReasonAggregateToJD", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
};

export const sendUpdatedAggregateReasonsToJD = async ({
  AssignContainerPlanningAggId,
  Reason,
  manualReason,
  SendApprovalBy,
}) => {
  if(Reason === "" && manualReason !== ""){
    let updatingData = {
      AssignContainerPlanningAggId:AssignContainerPlanningAggId,
      Reason : manualReason,
      SendApprovalBy
    }
  return await http.put(host + "UpdateReasonForDailyContainerPlanningAgg", updatingData);
}
else if(Reason !== "" && manualReason !== ""){
  let updatingData = {
    AssignConAssignContainerPlanningAggIdtainerPlanningId:AssignContainerPlanningAggId,
    Reason : `${Reason},${manualReason}`,
    SendApprovalBy
  }
  return await http.put(host + "UpdateReasonForDailyContainerPlanningAgg", updatingData);
} else{
  let updatingData = {
    AssignContainerPlanningAggId:AssignContainerPlanningAggId,
    Reason : `${Reason}`,
    SendApprovalBy
  }
  return await http.put(host + "UpdateReasonForDailyContainerPlanningAgg", updatingData);
}
};

export const sendAggregateBulkReasonsToJD = async (data) => {
  return await http.post(host + "InsertBulkAggregateBookingReason", {_jsonAggBookingReson:data});
};

export const responseOnAggregateFromJD = async ({
  assignContainerAggregateId,
  DeereStatus,
  DeereStatusBy,
}) => {
  const formData = new FormData();
  formData.append("assignContainerAggregateId", assignContainerAggregateId);
  formData.append("DeereStatus", DeereStatus);
  formData.append("DeereStatusBy", DeereStatusBy);
  return await http.put(host + "UpdateResponseAggregateFromJD", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateAggregateShipment = async (data) => {
  const formData = new FormData();
  formData.append("Id", data.DailyContainerPlanningAggregateId);
  formData.append("ColumnName", data.ColumnName);
  formData.append("PrevVal", data.PrevVal);
  formData.append("Value", data.Value);
  formData.append("UserId", getUser().uid);
  return await http.put(host + "UpdateSingleRowforAggregate", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateAggregateShipmentForInspection = async (data) => {
  const dataObj = {
    id: data.DailyContainerPlanningAggregateId,
    columnName: data.ColumnName,
    prevVal: data.PrevVal,
    value: data.Value,
  };
  return await http.put(host + "updateSingleRowforAggregateInspection", dataObj );
};

export const uploadAggregateBookingDocument = async (formData, dailyBookingId) => {
  return await http.put(host + `UpdateBookingDocumentAggregate?ContainerAggregateId=${dailyBookingId}`, formData)
}

export const GetAggregateDailyPlanningDataForSubrow = async (data) => {
  const response = await http.get(
    host + "GetAggregateDailyPlanningDetailedInfo",
    { params: { dailyContainerPlanningAggregateId: data } }
  );
  return response.data.map((item) => {
    return {
      ...item,
      ETA: standerdDate(item.ETA),
      ETD: standerdDate(item.ETD),
      Factory_In_Date: standerdDate(item.Factory_In_Date),
      Factory_Out_Date: standerdDate(item.Factory_Out_Date),
      JD_Stuffing_Date: standerdDate(item.JD_Stuffing_Date),
      Origin_Transit_Time: `${item.Origin_Transit_Time} days`,
      Ground_Rent_Days: `${item.Ground_Rent_Days} days`,
      Approx_container_detention: `${item.Approx_container_detention} days`,
    };
  });
};

export const GetAggregateDailyPlanningData= async (data) => {
  var planningDataArray = []
  for (let i = 0; i < data.length; i++) {
    const response = await http.get(
      host + "GetAggregateDailyPlanningDetailedInfo",
      { params: { DailyContainerPlanningAggregateId: data[i] } }
    );
    for (let i = 0; i < response.data.length; i++) {
      planningDataArray.push({
        ...response.data[i],
        ETA: standerdDate(response.data[i].ETA),
      ETD: standerdDate(response.data[i].ETD),
      Factory_In_Date: standerdDate(response.data[i].Factory_In_Date),
      Factory_Out_Date: standerdDate(response.data[i].Factory_Out_Date),
      JD_Stuffing_Date: standerdDate(response.data[i].JD_Stuffing_Date),
      Origin_Transit_Time: `${response.data[i].Origin_Transit_Time} days`,
      Ground_Rent_Days: `${response.data[i].Ground_Rent_Days} days`,
      Approx_container_detention: `${response.data[i].Approx_container_detention} days`,
      })
    }
  }
  return planningDataArray
};

export const deleteAggregateShipmentById = async (data,action) => {
  return await http.delete(host + "DeleteAggregateDailyPlanWithId", {params:{Id : data, _DeleteforTrans : action}})
}

export const deleteAggregateDailyPlan = async (date, action) => {
  return http.delete(host + 'DeleteAryabhattaAggregateDailyPlan', {params: {_date : date, _DeleteforTrans: action}})
} 
export const deleteAggregateMonthlyPlan = async (date) => {
  return http.delete(host + 'DeleteAggregateMonthlyPlan', {params: {_PlanningMonth : date}})
} 

export const getMaxAggregateContainerCount = async (date) => {
  return await http.get(host + "GetMaximumContainerCountAggregate", {params:{_date:date}})
}

export const updateBookingNumAggregate = async (data) =>{
  const formData = new FormData();
  formData.append("assignContainerPlanningAggregateId", data.assignContainerPlanningAggregateId);
  formData.append("bookingNo", data.bookingNo);
  formData.append("bookedBy", data.bookedBy);
  return await http.put(
    host + "UpdateBookingNumberForDailyContainerPlanningAggregate",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

export const DetailedMonthlyAggregateShipmentActualData = async (data) => {
  const response =  await http.get(host + "GetMonthlyAggregateShipmentActualData", {
    params: { _planningDate: data },
  });
  return response.data.map((item)=>{
    return{
      ...item,
      Date : standerdDateForDataCreation(item.Date)
    }
  })
};

export const updateAggregateBulkData = async (data) => {
  await http.put(host + "UpdateBulkDataForAggregate", {_jsonAggrBookingUpList:data})
}